import { TabularCopySink } from './tabular.copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { RelationalTableDataset } from 'app/model/dataset/relational-table.dataset';

import { OdbcDataset } from 'app/model/dataset/odbc.dataset';

@Metamodel.model({
    name: 'OdbcSink',
    display: [],
    referable: true,
    tags: { datasetModel: [
        Metamodel.modelFor(RelationalTableDataset),
        Metamodel.modelFor(OdbcDataset)
    ]}
})
export class OdbcSink extends TabularCopySink {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: stringResources.ModelName_WriteBatchSize
    })
    public writeBatchSize?: number = 0;
}
